import { Link } from "react-router-dom";

export function Panel({ title, icon: Icon, link, linkLabel = "Tümü", testId, className = "", children }) {
  return (
    <section data-testid={testId} className={`bg-white rounded-2xl border border-slate-200/80 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_8px_24px_-16px_rgba(15,23,42,0.12)] p-5 min-w-0 ${className}`}>
      <div className="flex items-center justify-between gap-3 mb-4">
        <h2 className="font-semibold text-slate-900 flex items-center gap-2 text-base" style={{ fontFamily: "Outfit, sans-serif" }}>
          {Icon && <span className="w-7 h-7 rounded-lg bg-emerald-50 text-emerald-700 flex items-center justify-center"><Icon className="w-4 h-4" /></span>}
          {title}
        </h2>
        {link && <Link to={link} data-testid={`${testId}-link`} className="text-xs font-semibold text-emerald-700 hover:text-emerald-800">{linkLabel}</Link>}
      </div>
      {children}
    </section>
  );
}

export const Empty = ({ children }) => <div className="text-sm text-slate-400 py-6 text-center">{children}</div>;

export function Row({ title, sub, right, testId }) {
  return (
    <div data-testid={testId} className="flex items-center justify-between gap-3 py-2.5 border-b border-slate-100 last:border-0">
      <div className="min-w-0">
        <div className="text-sm font-medium text-slate-800 truncate">{title}</div>
        {sub && <div className="text-xs text-slate-500 truncate">{sub}</div>}
      </div>
      {right && <div className="shrink-0 text-right">{right}</div>}
    </div>
  );
}
